import store from '../store';
import { logX } from '../common/libs/utils';
import http from './http';

export const getHistory = async uid => {
	const result = await http.get(process.env.VUE_APP_HISTORY_HOST + '/api/chats', { bid: store.state.bid, uid }, undefined, { noBase: true });

	store.state.chats = result.chats.map(c => {
		return {
			from: c.from,
			fid: c.from,
			msg: c.msg,
			ins_t: c.ins_t,
			id: c.id,
			newAdd: false,
			data: c,
			type: 'text',
			thumb: c.thumb
		};
	})

	logX('CHAT', 'blue', result);
	logX('CHAT_DISPLAY', 'blue', store.state.chats);
	return result;
}

export const sendDM = async data => {
	const message = {
		bid: store.state.bid,
		uid: store.state.uid,
		style: 'ipts',
		from: 'staff',
		ins_t: ~~(new Date().getTime() * 0.001),
		...(typeof data === 'object' ? data : { msg: data })
	}

	await http.post(process.env.VUE_APP_HISTORY_HOST + '/member/users/solved', { bid: message.bid, uid: message.uid, type: 'text', msg: message.type }, undefined, { noBase: true });
	await http.post(process.env.VUE_APP_HISTORY_HOST + '/api/chat', message, { Authorization: `Token ${window.token}` }, { noBase: true });

	store.state.chats = [...store.state.chats, {
		from: 'bot',
		fid: 'bot',
		msg: message.msg,
		ins_t: new Date().getTime(),
		id: Math.random().toString().replace('0.', ''),
		newAdd: false,
		data: {},
		type: message.type,
		thumb: null
	}];
}